import { useOutletContext } from 'react-router-dom';
import type { SupplierPriceListDetail } from '@/api/supplier-price-lists/supplier-price-lists.types';
import { SupplierFeedOverview } from './supplier-feed-overview.component';
import { SupplierFeedRuns } from './supplier-feed-runs.component';
import { SupplierFeedItems } from './supplier-feed-items.component';

interface FeedDetailContext {
  feed: SupplierPriceListDetail;
  feedId: string;
}

export function OverviewRoute() {
  const { feed } = useOutletContext<FeedDetailContext>();
  return <SupplierFeedOverview feed={feed} />;
}

export function RunsRoute() {
  const { feed, feedId } = useOutletContext<FeedDetailContext>();
  return (
    <SupplierFeedRuns
      feedId={feedId}
      feedName={feed.name}
      incompleteRunId={feed.incompleteRun?.id ?? null}
    />
  );
}

export function ItemsRoute() {
  const { feedId } = useOutletContext<FeedDetailContext>();
  return <SupplierFeedItems feedId={feedId} />;
}
